const __pages_import_0__ = () => import("/src/pages/wallet.vue");
const __pages_import_1__ = () => import("/src/pages/toast.vue");
import __pages_import_2__ from "/src/pages/index.vue";
const __pages_import_3__ = () => import("/src/pages/cards.vue");
const __pages_import_4__ = () => import("/src/pages/buttons.vue");

const routes = [{"name":"wallet","path":"/wallet","component":__pages_import_0__,"props":true},{"name":"toast","path":"/toast","component":__pages_import_1__,"props":true},{"name":"index","path":"/","component":__pages_import_2__,"props":true},{"name":"cards","path":"/cards","component":__pages_import_3__,"props":true},{"name":"buttons","path":"/buttons","component":__pages_import_4__,"props":true}];

export default routes;